import { RouteConfig } from 'vue-router';
import Breadcrumbs from './breadcrumbs';

const Home = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "Index" */ '@/views/Index');
const Verification = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "JudicalVerification" */ '../views/Verification/verification');
const LawyerLicenseVerification = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "LawyerLicenseVerification" */ '../views/LawyerLicenseVerification/lawyerLicenseVerification');

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/judicalVerification',
    name: 'judicalVerification',
    component: Verification,
    meta: {
      highlighted: true,
      breadcrumb: Breadcrumbs.judicalVerification,
    },
  },
  {
    path: '/lawyer/licenses/:licenseNumber',
    name: 'lawyerLicenseVerification',
    component: LawyerLicenseVerification,
    meta: {
      hideBreadcrumb: true,
    },
  },
];

export default routes;
